export const CHANGE_GROUP_STATUS_START = 'CHANGE_GROUP_STATUS_START';
export const CHANGE_GROUP_STATUS_SUCCESS =
  'CHANGE_GROUP_STATUS_SUCCESS';
export const CHANGE_GROUP_STATUS_ERROR = 'CHANGE_GROUP_STATUS_ERROR';
